// extracted by mini-css-extract-plugin
export var disabled = "_12-a";
export var hierarchyLinkGray = "_12-4";
export var hierarchyLinkUnderline = "_12-3";
export var hierarchyPrimary = "_12-0";
export var hierarchySecondary = "_12-1";
export var hierarchyTertiary = "_12-2";
export var pressed = "_12-6";
export var themeAction = "_12-5";
export var themeDestructive = "_12-8";
export var themeNormal = "_12-7";
export var themeSuccess = "_12-9";